import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 * ActionBarSlot — rend la barre CTA sticky bottom safe-area (Sprint 2.2 L3).
 *
 * Lit le snapshot du <ActionBarProvider> via useActionBarSnapshot.
 * Si aucun primary ni secondary n est set, la barre est masquée
 * (pas de div vide qui mange du padding).
 *
 * Layout :
 *   - sticky bottom-0 (suit le bord visible quand le viewport rétrécit, ex
 *     keyboard mobile sur intro avec input — futur)
 *   - env(safe-area-inset-bottom) + 16px pour rester au-dessus du home
 *     indicator iOS (PWA installée)
 *   - backdrop-blur pour séparation visuelle quand le contenu défile derrière
 */
import { useActionBarSnapshot } from '../hooks/useActionBar';
const DEFAULT_CLASSNAME = 'sticky bottom-0 -mx-s5 mt-s4 border-t border-cyan-border-faint bg-cyan-surface/96 px-s5 pt-s4 backdrop-blur-md';
export function ActionBarSlot({ className }) {
    const { primary, secondary } = useActionBarSnapshot();
    if (!primary && !secondary)
        return null;
    return (_jsx("footer", { "data-testid": "game-shell-action-bar", className: className ?? DEFAULT_CLASSNAME, style: { paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)' }, children: _jsxs("div", { className: "flex flex-col items-stretch gap-s3", children: [primary, secondary] }) }));
}
//# sourceMappingURL=ActionBarSlot.js.map